<template>
    <grid
        :fetchCallback="fetchCallback"
        :columnDefs="columnDefs"
        :maxBlocksInCache="null"
        :suppressScrollOnNewData="true"
        ref="grid"
    >
        <responsive-button
            variant="primary"
            @click="refresh"
            :icon="['fas', 'arrows-rotate']"
            >Refresh</responsive-button
        >
    </grid>
</template>

<script>
import API from '../../../api';
import grid from '../../generic/grid/grid.vue';
import { ADMIN_CHANNEL_ERRORS_AIRBNB_GRID } from '../../../endpoints';
import responsiveButton from '../../generic/responsive-button/responsive-button.vue';

export default {
    components: { grid, responsiveButton },
    data() {
        return {
            offset: 0,
            limit: 20,
            sort: 'created',
            desc: false,
            search: '',
        };
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'created',
                    headerName: 'Created',
                    type: 'dateTimeColumn',
                    sort: 'desc',
                    minWidth: 190,
                    width: 190,
                },
                {
                    field: 'created_user',
                    headerName: 'User Time',
                    type: 'dateTimeColumn',
                    minWidth: 190,
                    width: 190,
                },
                {
                    field: 'subscriber_id',
                    headerName: 'Subscriber #',
                    cellRenderer: ({ data }) => {
                        return `<a href="/app/admin/user/details/${data.subscriber_id}">${data.subscriber_id}</a>`;
                    },
                    maxWidth: 140,
                    minWidth: 140,
                },
                {
                    field: 'meta_res_id',
                    headerName: 'Invoice #',
                    maxWidth: 115,
                    minWidth: 115,
                },
                {
                    field: 'rental_property_id',
                    headerName: 'Rental Property #',
                    minWidth: 145,
                    width: 145,
                },
                {
                    field: 'from_date',
                    headerName: 'From Date',
                    type: 'dateColumn',
                    minWidth: 120,
                    width: 120,
                },
                {
                    field: 'to_date',
                    headerName: 'To Date',
                    type: 'dateColumn',
                    minWidth: 120,
                    width: 120,
                },
                {
                    field: 'channel',
                    headerName: 'Channel',
                    minWidth: 110,
                    width: 110,
                },
                {
                    field: 'errors',
                    headerName: 'Errors',
                    autoHeight: true,
                    wrapText: true,
                    sortable: false,
                    cellStyle: { whiteSpace: 'normal' },
                    minWidth: 400,
                },
                {
                    field: 'guest_name',
                    headerName: 'Guest Name',
                    minWidth: 120,
                },
                {
                    field: 'guest_email',
                    headerName: 'Guest Email',
                    minWidth: 120,
                },
            ];
        },
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return API.get(ADMIN_CHANNEL_ERRORS_AIRBNB_GRID(), {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                    },
                });
            };
        },
    },
    methods: {
        refresh() {
            this.$refs.grid.refreshDataSource();
        },
    },
};
</script>
